var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-contents"},[_c('router-view'),_c("template",{tag:"div",attrs:{"id":"loading-template"}},[_c('Loading',{attrs:{"variant":"primary-text"}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }